import { useEffect, useState } from "react";
import Table, { Column } from "../common/table";
import StaffService from "../../services/staff.service";
import { Staff } from "../../types/Staff";
import { classNames } from "../../utils/classNamesUtils";
import StaffModal from "./staff.modal";
import { useTranslation } from "react-i18next";

const userTypeStyles = {
    ADMIN: "bg-green-100 text-green-800",
    STAFF: "bg-yellow-100 text-yellow-800",
    MANAGER: "bg-blue-100 text-blue-800",
};

export default function StaffPage() {
    const { t } = useTranslation();

    const columns: Column<Staff>[] = [
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('staff.firstName')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.firstName}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('staff.lastName')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.lastName}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('staff.email')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.email}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('staff.phoneNumber')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.phoneNumber}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('staff.userType')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI}
                    className={classNames(
                        row.userType && userTypeStyles[row.userType],
                        "inline-flex items-center px-2.5 py-0.5 rounded-full text-left text-xs font-medium capitalize"
                    )}
                >
                    {row.userType}
                </td>
            ),
        },
    ];

    const [rows, setRows] = useState<any[]>([]);
    const [staffModalOpen, setStaffModalOpen] = useState(false);
    const [selectedStaffId, setSelectedStaffId] = useState<string | null>(null);

    const fetchData = async () => {
        const response = await StaffService.getStaff();
        const data = await response.json();
        setRows(data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleRowClick = (staffId: string) => {
        setSelectedStaffId(staffId);
        setStaffModalOpen(true);
    };

    const handleAdd = () => {
        setSelectedStaffId(null);
        setStaffModalOpen(true)
    };

    return (
        <>
            <StaffModal setOpen={setStaffModalOpen} open={staffModalOpen} rows={rows} onSave={fetchData} selectedStaffId={selectedStaffId}></StaffModal>

            <Table
                columns={columns}
                rows={rows}
                title={t('staff.staffTitle')}
                showAddButton={true}
                onAdd={handleAdd}
                currentPage={1}
                pageSize={1}
                totalRows={1}
                onRowClick={(staffMember: Staff) => handleRowClick(staffMember._id)}
            />
        </>
    );
}
